export default __webpack_public_path__ + "static/media/ic_simpleswaps.dad5764b.svg";